export type TechnologyCyberUserRole = 'ADMIN' | 'EXPERT' | 'INNOVATOR' | 'INTELLIGENCE' | undefined;

type TechnologyCyberAccessParams = {
  isChildOrganizationView: boolean;
  role: TechnologyCyberUserRole;
};

type GetTechnologyCyberEmptyStateMessageParams = {
  hasMilitaryTrlAssessments: boolean;
} & TechnologyCyberAccessParams;

const readOnlyTechnologyCyberRoles = new Set<TechnologyCyberUserRole>(['EXPERT', 'INTELLIGENCE']);

export const isReadOnlyTechnologyCyberView = (params: TechnologyCyberAccessParams): boolean => {
  const { isChildOrganizationView, role } = params;

  return isChildOrganizationView || readOnlyTechnologyCyberRoles.has(role);
};

export const canReadTechnologyCyberTab = (
  params: TechnologyCyberAccessParams & { hasCyberAssessmentsTool: boolean },
): boolean => {
  const { hasCyberAssessmentsTool, isChildOrganizationView, role } = params;

  return (
    hasCyberAssessmentsTool &&
    (isReadOnlyTechnologyCyberView({ isChildOrganizationView, role }) || role === 'INNOVATOR')
  );
};

export const canManageTechnologyCyberAssessments = (params: TechnologyCyberAccessParams): boolean => {
  const { isChildOrganizationView, role } = params;

  return role === 'INNOVATOR' && !isChildOrganizationView;
};

export const getTechnologyCyberEmptyStateMessage = (
  params: GetTechnologyCyberEmptyStateMessageParams,
): string | undefined => {
  const { hasMilitaryTrlAssessments, isChildOrganizationView, role } = params;

  if (isReadOnlyTechnologyCyberView({ isChildOrganizationView, role })) {
    return undefined;
  }

  if (!hasMilitaryTrlAssessments) {
    return 'You must complete a Military TRL before creating a Cyber Assessment.';
  }

  return 'Complete your first Cyber Assessment to unlock overview insights and history.';
};

export const shouldUseTechnologyCyberFullWidthEmptyState = (params: TechnologyCyberAccessParams): boolean => {
  return isReadOnlyTechnologyCyberView(params);
};
